import * as types from '../types'

/**
 * Set the enrollment product information in Redux state
 * @param {string} productId - The ID of the course, bundle, or digital product
 * @param {string} productType - Either 'course', 'bundle', or 'digital_product'
 */
export const setEnrollmentProduct = (productId, productType) => {
    return {
        type: types.SET_ENROLLMENT_PRODUCT,
        payload: {
            productId,
            productType
        }
    }
}

/**
 * Clear the enrollment product information from Redux state
 */
export const clearEnrollmentProduct = () => {
    return {
        type: types.CLEAR_ENROLLMENT_PRODUCT
    }
}
